module.exports = __webpack_public_path__ + "media/fonts/SFProText-Heavy-04f8a6c931ddf8b6ba806b87101a0001.svg";